import { makeAutoObservable } from 'mobx'
import { restClient } from '@/Core'
import type { Notify } from '@/Ship/Contracts/Notify'

/**
 * Local store of `ReportDelayModal`.
 * Owns driver's delay comment, submission flag, and the create-delay request.
 * Instantiated per modal mount via `useState(() => new ReportDelayModalStore())`.
 */
export class ReportDelayModalStore {
    comment = ''
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    setComment(v: string): void {
        this.comment = v
    }

    setLoading(v: boolean): void {
        this.loading = v
    }

    reset(): void {
        this.comment = ''
    }

    async submit(assignmentUuid: string, notify: Notify): Promise<boolean> {
        if (!this.comment.trim()) return false
        this.setLoading(true)
        try {
            await restClient.post(`/services/executor-assignments/${assignmentUuid}/delays`, {
                json: { driverComment: this.comment },
            })
            notify.success('Затримку зафіксовано')
            this.reset()
            return true
        } catch {
            notify.error('Помилка надсилання затримки')
            return false
        } finally {
            this.setLoading(false)
        }
    }
}
